import * as React from "react";
const SvgPlusMath = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 15, viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 7.5H11M7 3.5L7 11.5", stroke: "#495BD1", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgPlusMath;
